export function getClipPathForSector(angle: number): string {
    const centerX = 50; // Центр по оси X (50% от ширины)
    const centerY = 50; // Центр по оси Y (50% от высоты)
    const radius = 50; // Радиус (50% от ширины/высоты)

    // Преобразуем угол в радианы
    const radians = (angle * Math.PI) / 180;

    // Начальная точка (0 градусов)
    const x1 = centerX + radius * Math.cos(-Math.PI / 2);
    const y1 = centerY + radius * Math.sin(-Math.PI / 2);

    // Конечная точка
    const x2 = centerX + radius * Math.cos(radians - Math.PI / 2);
    const y2 = centerY + radius * Math.sin(radians - Math.PI / 2);

    // Создаем массив точек для clip-path
    let points = [
        `50% 50%`, // Центр
        `${x1}% ${y1}%`, // Начальная точка
        `${x2}% ${y2}%`, // Конечная точка
    ];

    // Добавляем дополнительные точки для создания закругленной части
    const steps = 1200; // Количество дополнительных точек
    for (let i = 1; i <= steps; i++) {
        const stepAngle = radians * (i / steps);
        const x = centerX + radius * Math.cos(stepAngle - Math.PI / 2);
        const y = centerY + radius * Math.sin(stepAngle - Math.PI / 2);
        points.push(`${x}% ${y}%`);
    }

    return `polygon(${points.join(', ')})`;
}